<template>
  <div>
    <span class="task" @click="openForm = true">Task</span>

    <div v-if="openForm">
      <div class="floating-new-lead-details">
        <div class="position-absolute">
          <date-picker
            v-model="newTask.taskDateTime"
            :first-day-of-week="1"
            type="datetime"
            :minute-step="1"
            :time-picker-options="timePickerOptions"
            input-class="form-control input-sm "
            lang="en"
          ></date-picker>
        </div>
        <div class="floating-sc-options">
          <input
            class="input-sc-status"
            type="search"
            placeholder="Select priority"
            v-model="newTask.taskPriority.title"
            data-toggle="dropdown"
          />

          <!--
                <button class="selector-btn" >
                  {{
                  newTask.taskPriority
                  ? newTask.taskPriority.title
                  : "Priority"
                  }}
                </button>-->
          <ul class="p-xy-8 dropdown-menu assignment-dropdown-menu ">
            <li
              class="assign-menu-item"
              v-for="type in taskDictionaries.general.task_priority_types"
              :key="type.id"
              @click="newTask.taskPriority = type"
            >
              {{ type.title }}
            </li>
          </ul>
        </div>

        <div class="floating-sc-options">
          <span class="input-sc-status" type="search" data-toggle="dropdown"
            >{{ newTask.taskUser.length + " users selected" }}
          </span>

          <ul class="p-xy-8 dropdown-menu  assignment-dropdown-menu ">
            <div class="add-tag-menu-item-title">
              Select User
            </div>
            <!--            <li-->
            <!--              v-for="(opt, idx) in FilterStatsNonActiveUsers()"-->
            <!--              :key="idx"-->
            <!--            >-->
            <!--              <input-->
            <!--                type="checkbox"-->
            <!--                class="item-checkbox"-->
            <!--                v-model="newTask.taskUser"-->
            <!--                :value="opt"-->
            <!--                :id="opt.id"-->
            <!--              />-->
            <!--              <label class="item-text" :title="opt.full_name"  :for="opt.id">{{-->
            <!--                opt.full_name | truncate(14)-->
            <!--              }}</label>-->
            <!--            </li>-->

            <li v-for="(opt, idx) in FilterStatsNonActiveUsers()" :key="idx">
              <label class="multi-check-label" :for="opt.id" @click="click">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="newTask.taskUser"
                  :value="opt"
                  :id="opt.id"
                />

                {{ opt.full_name }}
              </label>
            </li>
          </ul>
        </div>

        <textarea
          class="form-control input-sm comment-box-scheduled "
          placeholder="Task"
          v-model.trim="newTask.taskText"
          maxlength="160"
        ></textarea>
        <span class="text-counter-scheduled"
          >{{ newTask.taskText.length }}/160</span
        >
        <!--            <p v-if="scheduledCallCommentError.length > 0" class="help-block">
              {{ scheduledCallCommentError }}
            </p>-->

        <tag-form-buttons
          @accepted="
            $emit('task', {
              assign_to: newTask.taskUser,
              priority_id: newTask.taskPriority.id,
              content: newTask.taskText,
              due_date: newTask.taskDateTime,
              deposit: deposit
            });
            openForm = false;
            resetAllForms();
          "
          @cancelled="
            openForm = false;
            resetAllForms();
          "
        ></tag-form-buttons>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import apiClientCreator from "../../../helpers/api/request";
import DatePicker from "vue2-datepicker";
import TagFormButtons from "../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/tags/TagFormButtons";
import UsersStatsActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";
export default {
  name: "ExternalTaskRequestForm.component",
  mixins: [UsersStatsActiveScope],
  components: {
    DatePicker,
    TagFormButtons
  },
  props: {
    deposit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchUserNameQuery: null,
      searchUserNameQueryResult: [],
      showUsersResults: false,
      openForm: false,
      newTask: {
        taskText: "",
        taskType: null,
        taskUser: [],
        taskGroup: [],
        taskPriority: {
          id: 2,
          type: "LOW",
          title: "Low Priority"
        },
        taskDateTime: null
      },
      timePickerOptions: {
        start: "09:00",
        step: "00:15",
        end: "23:45"
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("tasks", ["taskDictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  methods: {
    click() {},
    resetAllForms() {
      (this.newTask.taskText = ""), (this.newTask.taskType = null);
      this.newTask.taskUser = [];
      this.newTask.taskGroup = [];
      this.newTask.taskPriority = {
        id: 2,
        type: "LOW",
        title: "Low Priority"
      };
      this.newTask.taskDateTime = null;
      this.openForm = false;
    },

    filterVpOpManager(data) {
      return data.filter(user => user.role === 3 || user.role === 4);
    },

    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              // The last word - ok with the word being "startswith"-like
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              // Not the last word - expect the whole word exactly
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.salesPersonList.filter(item => {
        return searchRegex.test(item.full_name);
      });
    }
  }
};
</script>

<style scoped>
.task {
  background-color: #2c4762;
  color: white;
  font-size: 9pt;
  margin: 2px;
  padding: 3px;
  cursor: pointer;
  font-family: "Segoe UI", Arial, sans-serif !important;
  line-height: 2;
}

.assignment-dropdown-menu {
  top: 70px;
  left: 10px;

  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.assignment-dropdown-menu ul {
  list-style: none;
  padding-left: 0;
}

.assignment-dropdown-menu li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
  cursor: pointer;
}

.assignment-dropdown-menu li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.assignment-dropdown-menu .item-text {
  vertical-align: middle;
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
}
.assignment-dropdown-menu .item-checkbox {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 5px;
}

.add-task-form {
  position: absolute;
  top: 10px;
  left: 0px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;

  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.add-tag-menu-item-title {
  margin: 5px;
  font-size: 9pt;
  font-weight: bold;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.cancel-edit-menu-item {
  color: #f44336;
  font-weight: bold;
}
.dropdown-menu {
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}
.assign-menu-item {
  margin: 5px;
  font-size: 9pt;
  font-family: "SegoePro-Regular", Arial, sans-serif;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.selector-btn {
  border: none;
  background: none;
  padding: 2px;
  border-radius: 3px;
}
.selector-btn:hover {
  background: #9e9e9e;
}
.tag-form-btns {
  position: absolute;
  right: 130px;
  display: flex;
  width: 60px;
}
.pointer {
  cursor: pointer;
}
.floating-new-lead-details {
  position: absolute;
  top: -15px;
  right: 40px;
  width: 270px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.input-sc-status {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 9pt;
  box-sizing: border-box;
}
.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}

.top-check-div {
  display: inline-flex;
}
</style>
